export default __webpack_public_path__ + "b3271b101d16f481366c482e55a3a759.woff";